export default {
    message: {
        "availability": "Disponibilità",
        "shipping_preparation": "Consegna del pacco prevista in",
        "days": "Giorni",
        "quantity": "Quantità",
        "add_to_cart": "Aggiungi al carrello",
        "quantity_no_available": "Quantità indicata non disponibile",
        "product_no_available": "Prodotto in arrivo",
        "choose": "Scegli",
        "Loading": "Caricamento in corso ...",
    },
}
